<template>
    <div class="container">
        <div class="row">
            <div class="col-12 col-lg-4">
                <h2 class="h h--2 h--dark">Nagrody dla Certyfikowanego Instalatora</h2>
                <p class="paragraph">Poznaj i zamawiaj nagrody, jakie przygotowaliśmy w Programie Geberit Pro.</p>
            </div>
            <div class="col-12 col-lg-8 prizes__wraper" v-bind:class="{'pending': pagination.pending}">
              <div class="row row-eq-height prizes__list">
                  <div class="col-12 col-md-6 col-lg-3 prizes__col" v-for="prize in prizes" :key="prize.id">
                      <div class="prizes__item">
                          <div class="prizes__item-img">
                              <img v-auth-image="'/photos/'+ prize.photos[0].id + '?thumbnail=300'" alt="" v-if="prize.photos.length > 0">
                          </div>
                          <div class="prizes__item-desc">
                              <p>{{ prize.name }}</p>
                              <div class="prizes__item-footer">
                                  <p><b>{{ prize.value }} pkt</b></p>

                                  <router-link
                                  v-if="(prize.cert_only == 1 && user.user_type_id == 3 && user.is_certyficated) || (prize.cert_only == 0 && user.is_invoiced)"
                                  :to="{name: 'InstalatorPrize', params: { id: prize.id }}"
                                  class="button button--small button--blue prizes__item-button">
                                  Zamów &raquo;
                                  </router-link>

                                  <button
                                    v-if="prize.cert_only == 1 && (user.user_type_id == 1 || user.user_type_id == 2 || (user.user_type_id == 3 && !user.is_certyficated))"
                                    id="show-modal"
                                    @click="show"
                                    class="button button--small button--azure prizes__item-button">
                                      Wymaga certyfikatu
                                  </button>
                                  <button
                                    v-if="prize.cert_only == 0 && !user.is_invoiced"
                                    id="show-modal-2"
                                    @click="show2"
                                    class="button button--small button--azure prizes__item-button">
                                      Zarejestruj fakturę!
                                  </button>
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
            </div>
            <div class="uncertified-user-modal">
            <modal name="uncertified-user-modal">
                <div class="row h-100">
                  <span @click="hide" class="prize__close"></span>

                  <div class="col-12 col-md-5 d-flex justify-content-center align-items-center uncertified-user-modal__img">
                     <img class="" src="../../../assets/img/certify_badge_image.png">
                  </div>
                  <div class="col-12 col-md-7 d-flex justify-content-center align-items-center uncertified-user-modal__desc">
                    <div>
                      <h2><strong>Brak certyfikacji</strong></h2>
                      <p>Nie możesz wymienać punktów na nagrody, bo nie jesteś certyfikowanym użytkownikiem</p>
                      <router-link :to="{name: 'Rules'}" tag="button" class="button button--small button--filled-blue prizes__item-button prizes__item-button--wide">
                        Sprawdź jak nim zostać &raquo;
                      </router-link>
                    </div>
                  </div>
                </div>
            </modal>
            </div>
            <div class="uninvoiced-user-modal">
              <modal name="uninvoiced-user-modal">
                <div class="row h-100">
                  <span @click="hide" class="prize__close"></span>

                  <div class="col-12 col-md-5 d-flex justify-content-center align-items-center uninvoiced-user-modal__img">
                   <img class="" src="../../../assets/img/certify_badge_image.png">
                 </div>
                 <div class="col-12 col-md-7 d-flex justify-content-center align-items-center uninvoiced-user-modal__desc">
                  <div>
                    <h2><strong>Brak certyfikacji</strong></h2>
                    <p>Nie możesz wymienać punktów na nagrody, bo nie jesteś certyfikowanym użytkownikiem</p>
                    <router-link :to="{name: 'Rules'}" tag="button" class="button button--small button--filled-blue prizes__item-button prizes__item-button--wide">
                      Sprawdź jak nim zostać &raquo;
                    </router-link>
                  </div>
                </div>
              </div>
            </modal>
          </div>
        </div>
        <page-box-set-widget></page-box-set-widget>
    </div>
</template>

<script>
import Vue from 'vue'
import Vue2Filters from 'vue2-filters'

export default {
  name: 'InstalatorPrizesComponent',
  mixins: [Vue2Filters.mixin],
  data () {
    return {
      prizes: [],
      pagination: {}
    }
  },
  beforeRouteEnter(to, from, next) {
    Vue.axios.all([
      Vue.axios({
        method: 'get',
        url: '/prizes/certified'
      })
    ])
    .then(Vue.axios.spread((prizesReponse) => {
      next(vm => {
        vm.prizes = prizesReponse.data.data.prizes;
      })
    }))
    .catch(error => next(false))
  },
  methods: {
    handleOk (evt) {
      // Prevent modal from closing
      evt.preventDefault()
      if (!this.name) {
        alert('Please enter your name')
      } else {
        this.handleSubmit()
      }
    },
    handleSubmit () {
      this.names.push(this.name)
      this.clearName()
      this.$refs.modal.hide()
    },

    /**
     * On change paginate event.
     *
     * @param  {int} page
     * @return void
     */
    onChangePaginate(page) {
      let vm = this

      vm.pagination.pending = true

      Vue.axios({
        method: 'get',
        url: '/prizes',
        params: {
          page: page
        }
      })
      .then(response => {
        vm.prizes = response.data.data.prizes
        vm.pagination = response.data.pagination
      })
      .catch(error => vm.pagination.pending = false)
    },

    show () {
      this.$modal.show('uncertified-user-modal');
    },
    hide () {
      this.$modal.hide('uncertified-user-modal');
    },
    show2 () {
      this.$modal.show('uninvoiced-user-modal');
    },
    hide2 () {
      this.$modal.hide('uninvoiced-user-modal');
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/home/instalatorPrizes/InstalatorPrizesComponent.vue